enum CardLabel {
  FinalHours = "Final Hours",
  FinalCost = "Final Cost",
}

export default CardLabel;
